/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ years: NonNullable<unknown> }} Tld_Pricing_Costs_YearsInputs */

const id_tld_pricing_costs_years = /** @type {(inputs: Tld_Pricing_Costs_YearsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years} tahun`)
};

const en_tld_pricing_costs_years = /** @type {(inputs: Tld_Pricing_Costs_YearsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years} yr`)
};

/**
* | output |
* | --- |
* | "{years} yr" |
*
* @param {Tld_Pricing_Costs_YearsInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_costs_years = /** @type {((inputs: Tld_Pricing_Costs_YearsInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Costs_YearsInputs, { locale?: "id" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_costs_years(inputs)
	return id_tld_pricing_costs_years(inputs)
});